export default __webpack_public_path__ + "static/media/3e8450b83bedc0b0.cb6e4a3969d314fa74574f007d113cac.svg";